import QRCode from '@components/shared/QRCode'
import * as React from 'react'
import { config } from 'react-awesome-styled-grid'
import styled from 'styled-components'
import { colors } from '../components/shared/colors'
import Badges from './Badges'

type PropsType = {
  title?: string,
  color?: string,
  webApp?: boolean
}
export default function ReadyToListen ({ title, color, webApp }: PropsType): React.ReactNode {
  return (
    <CenterDiv>
      <LogoImg src="/images/dipsea-logo.png" />
      <CtaText color={color} textAlign={'center'}>{title || 'Dive into Dipsea.'}</CtaText>
      <QRCodeContainer>
        <QRCode/>
      </QRCodeContainer>
      <Badges color={color} badgesOnly={true} signup={false} webApp={webApp} />
    </CenterDiv>
  )
}

const CenterDiv = styled.div<any>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const LogoImg = styled.img<any>`
  display: block;
  margin-bottom: 20px;
  width: 86px;
`
const CtaText = styled.h2<any>`
  text-align: center;
  color: ${(props: any): string => props.color || colors.white};
  font-family: 'Queens Condensed Light';
  font-style: normal;
  font-weight: ${(props: any): number => props.fontWeight || 300};
  letter-spacing: ${(props: any): number => props.letterSpacing || 0};
  text-align: ${(props: any): any => props.textAlign || 'left'};
  margin: 0;
  font-size: 36px;
  line-height: 43px;
  
  margin-bottom: 28px;
  
  ${(props: any): any => config(props).media.md`
    margin-bottom: 20px;
  `}
  
  ${(props: any): any => config(props).media.lg`
    font-size: 45px;
    line-height: 54px;
    margin-bottom: 28px;
  `}
`
const QRCodeContainer = styled.div<any>`
  margin-bottom: 24px;
`
